/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste binary (0s and 1s)…`)
};

const es_tb_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega binario (0s y 1s)…`)
};

const de_tb_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binärcode einfügen (0 und 1)…`)
};

const nl_tb_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak binair (0en en 1en)…`)
};

const fr_tb_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez du binaire (0 et 1)…`)
};

const it_tb_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla binario (0 e 1)…`)
};

const pt_br2_tb_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole binário (0s e 1s)…`)
};

const pt_tb_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole binário (0s e 1s)…`)
};

const ja_tb_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイナリを貼り付けてください (0 と 1)…`)
};

const zh_tb_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴二进制(0和1)…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_placeholder_decode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_placeholder_decode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_placeholder_decode", locale)
	if (locale === "en") return en_tb_placeholder_decode(inputs)
	if (locale === "es") return es_tb_placeholder_decode(inputs)
	if (locale === "de") return de_tb_placeholder_decode(inputs)
	if (locale === "nl") return nl_tb_placeholder_decode(inputs)
	if (locale === "fr") return fr_tb_placeholder_decode(inputs)
	if (locale === "it") return it_tb_placeholder_decode(inputs)
	if (locale === "pt-BR") return pt_br2_tb_placeholder_decode(inputs)
	if (locale === "pt") return pt_tb_placeholder_decode(inputs)
	if (locale === "ja") return ja_tb_placeholder_decode(inputs)
	return zh_tb_placeholder_decode(inputs)
};